<template>
    <div class="mt-5 w-full flex align-items-center justify-content-center">
        <div class="w-full flex flex-column align-items-center p-6" style="color: var(--theme-font-color); min-width: 15rem; max-width: 35rem; width: 88vw; border: 1px solid var(--theme-color5); border-radius: 18px;">
            <span style="color: var(--theme-font-color); font-size: var(--register-maintitle-font-size); font-weight: var(--register-maintitle-font-weight);" class="text-center">Register</span>
            <div class="mt-5 flex-column align-items-center" style="gap: 0.7rem; width: 100%;" :class="{ 'flex': !httpRegisterLoading, 'hidden': httpRegisterLoading}">
                <div class="registerlogin-section">
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">First Name<span style="color: var(--mydanger-color);">*</span></span>
                        <InputText class="w-full register-inputtext" v-model="firstName" aria-describedby="admin-help" :class="{ 'p-invalid': errorFirstNameMessage && isValidFirstName(firstName)!=='success' }"/>
                        <span v-if="errorFirstNameMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorFirstNameMessage }}</span>
                    </div>
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Last Name<span style="color: var(--mydanger-color);">*</span></span>
                        <InputText class="w-full register-inputtext" v-model="lastName" aria-describedby="admin-help" :class="{ 'p-invalid': errorLastNameMessage && isValidLastName(lastName)!=='success' }"/>
                        <span v-if="errorLastNameMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorLastNameMessage }}</span>
                    </div>
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Company</span>
                        <InputText class="w-full register-inputtext" v-model="company" aria-describedby="admin-help" :class="{ 'p-invalid': errorCompanyMessage && isValidCompany(company)!=='success' }"/>
                        <span v-if="errorCompanyMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorCompanyMessage }}</span>
                    </div>
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Country</span>
                        <CountryDropdown dropdownSize="big" initialSelectedCountryCode="" @selectCountry="(val) => country = val" :selectedCountryCode="country"/>
                    </div>
                </div>
                
                <div class="registerlogin-section">
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Email<span style="color: var(--mydanger-color);">*</span></span>
                        <InputText class="w-full register-inputtext" v-model="email" aria-describedby="admin-help" :class="{ 'p-invalid': (errorEmailMessage && isValidEmail(email)!=='success') || accountAlreadyExists }"/>
                        <span v-if="errorEmailMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorEmailMessage }}</span>
                        <span v-if="accountAlreadyExists" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">There is already an account with this email address. Sign in instead.</span>
                    </div>
                </div>
                <div class="registerlogin-section">
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Password<span style="color: var(--mydanger-color);">*</span></span>
                        <PasswordInputText v-model:val="password" class="register-password" uid="passwordRegister" @update-val="(val) => password=val" :isInvalid="errorPasswordMessage && isValidPasswordRegister(password)!=='success'"/>
                        <span v-if="errorPasswordMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorPasswordMessage }}</span>
                    </div>
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Password Confirmation<span style="color: var(--mydanger-color);">*</span></span>
                        <PasswordInputText v-model:val="password2" class="register-password" uid="passwordRegister2" @update-val="(val) => password2=val" :isInvalid="password !== password2"/>
                        <span v-if="!errorPasswordMessage" class="error-message mb-2" style="font-size: var(--font-size-small); color: var(--theme-font-color); opacity: 0.6;">{{ invalidPasswordMessage }}</span>
                    </div>
                </div>
                <TurnstileWidget widgetId="registerTurnstileWidget" @human-verified="(token) => {turnstileToken = token; isHumanVerified = true}"/>
                <div class="flex flex-column w-full gap-2 align-items-center">
                    <ButtonModule type="primary" severity="normal" label="Register" @click="clickedRegister(firstName, lastName, company, country, email, password)" :disabled="!enableRegister" class="mb-4"/>
                    <span style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">
                        Already have an account?
                        <router-link unstyled :to="{ path: '/login'}" style="text-decoration: none;">
                            <span id="go-to-login-text" class="cursor-pointer" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">Sign in.</span>
                        </router-link>
                    </span>
                </div>
            </div>

            <div v-if="httpRegisterLoading" style="height: 65vh;" class="flex align-items-center justify-content-center">
                <LoadingSpinner/>
            </div>
        </div>

        <!-- DIALOGS -->

        <!-- RegistrationDone window -->
        <RegistrationDone :showDialog="showRegistrationDoneDialog" :account="createdAccountInfo" :invitation="invitation" @close="showRegistrationDoneDialog = false; router.push({ path: '/login' });"/>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, watchEffect, computed, onMounted, onBeforeUnmount, toRefs } from 'vue';
// PrimeVue
import InputText from 'primevue/inputtext';
// vue
import PasswordInputText from '@/components/Modules/PasswordInputText.vue'
import ButtonModule from '@/components/Modules/ButtonModule.vue'
import CountryDropdown from '@/components/Modules/CountryDropdown.vue';
import RegistrationDone from '@/components/Dialogs/OtherDialogs/RegistrationDone.vue'
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
import TurnstileWidget from '@/components/Modules/TurnstileWidget.vue';
// Others
import InputsUtils from '@/composables/InputsUtils'
import toastService from '@/composables/toastService';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';

// API
import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchRegister } = useApiRequest()
const httpRegisterLoading = ref(false)
const httpRegisterData = ref(null)  

const router = useRouter()
const store = useStore()
const { isValidFirstName, isValidLastName, isValidCompany, isValidEmail, invalidPasswordMessage, isValidPasswordRegister } = InputsUtils()

// --- PROPS ---
const props = defineProps({
    invitation: String
})
const { invitation } = toRefs(props)

// --- REDIRECT IF ALREADY CONNECTED ---
const isLoggedIn = computed(() => store.getters['user/isLoggedIn'])
watchEffect(() => {
    if (isLoggedIn.value) { router.push({ path: '/licenses' }) }
})

// --- VARIABLES ---
const firstName = ref(null)
const lastName = ref(null)
const company = ref(null)
const country = ref(null)
const email = ref(null)
const password = ref(null)
const password2 = ref(null)

// Errors
const errorFirstNameMessage = ref(null)
const errorLastNameMessage = ref(null)
const errorCompanyMessage = ref(null)
const errorEmailMessage = ref(null)
const errorPasswordMessage = ref(null)
const accountAlreadyExists = ref(false)

// Registration Done Window
const createdAccountInfo = ref(null)
const showRegistrationDoneDialog = ref(false)
const emailAccountCreated = ref('')

// --- Click register ---
const enableRegister = computed(() => isHumanVerified.value && firstName.value && lastName.value && email.value && password.value && password2.value && (password.value===password2.value))
const clickedRegister = async (myFirstName, myLastName, myCompany, myCountry, myEmail, myPassword) => {
    errorFirstNameMessage.value = null
    errorLastNameMessage.value = null
    errorCompanyMessage.value = null
    errorEmailMessage.value = null
    errorPasswordMessage.value = null
    accountAlreadyExists.value = false
    var validSubmit = true
    // Check if valid FirstName
    const isValidFirstNameMessage = isValidFirstName(myFirstName)
    if (isValidFirstNameMessage !== 'success') { errorFirstNameMessage.value = isValidFirstNameMessage; validSubmit = false }
    // Check if valid LastName
    const isValidLastNameMessage = isValidLastName(myLastName)
    if (isValidLastNameMessage !== 'success') { errorLastNameMessage.value = isValidLastNameMessage; validSubmit = false }
    // Check if valid Company
    if (myCompany!==null) {
        const isValidCompanyMessage = isValidCompany(myCompany)
        if (isValidCompanyMessage !== 'success') { errorCompanyMessage.value = isValidCompanyMessage; validSubmit = false }
    }
    // Check if valid Email
    const isValidEmailMessage = isValidEmail(myEmail)
    if (isValidEmailMessage !== 'success') { errorEmailMessage.value = isValidEmailMessage; validSubmit = false }
    // Check if valid Password
    const isValidPasswordMessage = isValidPasswordRegister(myPassword)
    if (isValidPasswordMessage !== 'success') { errorPasswordMessage.value = isValidPasswordMessage; validSubmit = false }

    // If the conditions are ok : go on
    if (!validSubmit) {
        password.value = null
        password2.value = null
        return
    }
    errorFirstNameMessage.value = null
    errorLastNameMessage.value = null
    errorCompanyMessage.value = null
    errorEmailMessage.value = null
    errorPasswordMessage.value = null

    // Send HTTP request
    httpRegisterLoading.value = true
    try {
        window.turnstile.reset("#registerTurnstileWidget")
        if (invitation.value) {
            createdAccountInfo.value = { "invitation": invitation.value, "first_name": myFirstName, "last_name": myLastName, "company": myCompany, "country": myCountry, "email": myEmail, "password_plain": myPassword }
            httpRegisterData.value = await fetchRegister({ invitation: invitation.value, first_name: myFirstName, last_name: myLastName, company: myCompany, country: myCountry, email: myEmail, password_plain: myPassword, cf_turnstile_response : turnstileToken.value })
        } else {
            createdAccountInfo.value = { "first_name": myFirstName, "last_name": myLastName, "company": myCompany, "country": myCountry, "email": myEmail, "password_plain": myPassword }
            httpRegisterData.value = await fetchRegister({ first_name: myFirstName, last_name: myLastName, company: myCompany, country: myCountry, email: myEmail, password_plain: myPassword, cf_turnstile_response : turnstileToken.value })
        }

        // Reset of values
        firstName.value = null
        lastName.value = null
        company.value = null
        country.value = null
        email.value = null
        password.value = null
        password2.value = null
        accountAlreadyExists.value = false
        // Show RegistrationDone window
        emailAccountCreated.value = myEmail
        showRegistrationDoneDialog.value = true
    } catch (err) {
        handleRegisterError(err)
    } finally {
        password.value = null
        password2.value = null
        httpRegisterLoading.value = false
    }
}
// Handle an error from the server
const handleRegisterError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Register: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // Missing info = MISSING_OBJ / MISSING_OBJ_ELEM (400) => toast
                if (errorCode == 'MISSING_OBJ' || errorCode == 'MISSING_OBJ_ELEM') {
                    toastService.add({ severity: 'warn', summary: "Register: Missing Information.", detail: 'It seems that the request body does not contain the necessary information.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Register: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 401: // Too much emails sent = EMAIL_SENDING_LIMIT_REACHED (401) => toast
                if (errorCode == 'EMAIL_SENDING_LIMIT_REACHED') {
                    toastService.add({ severity: 'warn', summary: "Register: Error Sending Limit.", detail: 'Too much emails have been sent to this address recently; the confirmation email is not sent. Try later.', life: 5000 });
                } else if (errorCode == 'CLOUDFLARE_TURNSTILE_INVALID') {
                    toastService.add({ severity: 'error', summary: `Register: Cloudflare Verification Error.`, detail: "The Cloudflare verification is no longer valid — this can happen if too much time passes before submitting. Please redo the verification and try again.", life: 10000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Register: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 409: // Account already register = ACCOUNT_ALREADY_EXISTS (409) => accountAlreadyExists
                if (errorCode == 'ACCOUNT_ALREADY_EXISTS') {
                    accountAlreadyExists.value = true
                }
                else {  toastService.add({ severity: 'error', summary: `Register: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 500: // DATABASE_ERROR / EMAIL_ERROR (500) => toast
                if (errorCode == 'EMAIL_ERROR') {
                    toastService.add({ severity: 'error', summary: "Register: Email Sending.", detail: 'Our server did not manage sending the confirmation email to the address you provided. Make sure it is a valid address email.', life: 5000 });
                    errorEmailMessage.value = "Please enter a valid email."
                }
                else if (errorCode == 'DATABASE_ERROR'){
                    toastService.add({ severity: 'error', summary: "Register: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Try later.', life: 5000 });
                }
                else {
                    toastService.add({ severity: 'error', summary: `Register: Error ${errorStatus}.`, detail: errorMessage, life: 12000 });
                }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Register: Error ${errorStatus}.`, detail: errorMessage, life: 12000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Register: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}

// --- ENTER key listener ---
onMounted(() => {
    window.addEventListener('keydown', handleKeyPressed)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPressed)
}) 
const handleKeyPressed = (event) => {
    if (event.keyCode === 13) { // ENTER
        if (enableRegister.value) { clickedRegister(firstName.value, lastName.value, company.value, country.value, email.value, password.value) }
    }
}

// --- TURNSTILE ---
const turnstileToken = ref(null)
const isHumanVerified = ref(false)
</script>

<style scoped>
/* Label */
.subtitle {
    font-size: var(--register-subtitle-font-size);
    font-weight: var(--register-subtitle-font-weight);
    opacity: 0.7;
}
/* InputText */
:deep(.p-inputtext) {
    height: 2.5rem
}
/* Go to login */
#go-to-login-text {
    text-decoration: none;
    color: var(--button-normal-color);
}
#go-to-login-text:visited {
    color: var(--button-normal-color);
}
#go-to-login-text:hover {
    border-bottom: 1px solid var(--button-normal-color);
}
</style>